import styles from "./PageLoader.module.css";

// Shown while a code-split page chunk is downloading (Suspense fallback).
// Mirrors the pre-React loader in public/index.html so the hand-off is seamless.
export default function PageLoader() {
  return (
    <div className={styles.loader} role="status" aria-live="polite">
      <img
        className={styles.logo}
        src="/visible-online.png"
        alt=""
        width="174"
        height="58"
        decoding="async"
      />
      <div className={styles.bar} aria-hidden="true">
        <span />
      </div>
      <span className={styles.text}>Loading…</span>
    </div>
  );
}
